<template>
	<el-dropdown size="small" class="d2-mr">
		<span class="btn-text">{{info.name ? `你好 ${info.name}` : '未登录'}}</span>
		<el-dropdown-menu slot="dropdown">			
			<el-dropdown-item @click.native="changePassword">
				<d2-icon name="key" class="d2-mr-5" />
				修改密码
			</el-dropdown-item>
			<el-dropdown-item @click.native="logOff">
				<d2-icon name="power-off" class="d2-mr-5" />
				注销
			</el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex'
	import {
		UpdateMyPassword
	} from '@api/UserInfo.js'
	export default {
		computed: {
			...mapState('d2admin/user', [
				'info'
			])
		},
		methods: {
			...mapActions('d2admin/account', [
				'logout'
			]),
			/**
			 * @description 登出
			 */
			logOff() {
				this.logout({
					confirm: true
				})
			},
			//修改我的密码
			changePassword() {
				this.$prompt('请输入新密码：', '修改我的密码', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^[a-zA-Z]\w{5,17}$/,
					inputErrorMessage: '以字母开头的6~18字符，可填字母、数字和下划线',
					closeOnClickModal:false,
				}).then(({
					value
				}) => {
					UpdateMyPassword({
							Password: this.$md5(value)
						})
						.then(res => {
							this.$message.success(res)
						})
				}).catch(() => {})
			},
		}
	}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
